import React, {
  useReducer,
  useCallback,
  useEffect,
  useState,
  useMemo,
} from 'react';
import Table, { TableColumn } from '../../components/Table';
import LoadingOverlay from '../../components/LoadingOverlay';
import { Reducer, InitialState } from './actions/reducer';
import { createFormatProvider } from '../../services/providers/factories';
import FilterFormTransactions from './components/FilterForm';
import { IFilterTransactionsProps } from './types';
import {
  getAllTransactions,
} from './actions';
import {
  Container,
  TableContainer,
} from './styles';
import { T2 } from '../../styles/titles';

const Usuarios: React.FC = () => {
  const [state, dispatch] = useReducer(Reducer, InitialState);
  const [pageSize, setPageSize] = useState<number>(20);
  const [offSet] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [filterOrder, setFilterOrder] = useState<any>();

  const fetchAllUsers = useCallback(() => getAllTransactions(offSet, pageSize)(dispatch), []);
  useEffect(() => {
    fetchAllUsers();
  }, [fetchAllUsers]);

  const formatProvider = useMemo(() => createFormatProvider(), []);
  const formattedDate = (date: string) => formatProvider.formatDate(Date.parse(date));

  const { format } = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

  const formatFee = (value: number) => {
    const feeFormated = Math.abs(value);
    const fee = `${feeFormated.toFixed(2)}%`;
    return fee;
  }

  const fetchAllTransactionsPagination = (initialPage: number, finalPage :number) => {
    getAllTransactions(initialPage, finalPage, filterOrder)(dispatch);
  }

  const handleUserFilter = async (filter: IFilterTransactionsProps) => {
    setFilterOrder(filter);
    getAllTransactions(offSet, pageSize, filter)(dispatch);
  };

  useEffect(() => {
    if (currentPage > 1) {
      fetchAllTransactionsPagination(pageSize * (currentPage - 1), (currentPage * pageSize))
    }
    if (currentPage === 1) {
      fetchAllTransactionsPagination(0, (currentPage * pageSize));
    }
  }, [currentPage, pageSize]);

  const transactions = state?.transactions?.records.map((transaction) => (
    {
      ...transaction,
    }
  ));

  return (
    <Container>
      <LoadingOverlay
        show={state.isPaymentModalOpen ? false : state.loading}
        relative
      />
      <T2>Transações Nossa Cidade</T2>
      <FilterFormTransactions
        onFormSubmit={handleUserFilter}
      />
      <TableContainer>
        <Table
          dataSource={transactions}
          pagination={
            {
              showSizeChanger: true,
              onShowSizeChange: (current: number, size: number) => {
                setPageSize(size);
              },
              defaultPageSize: 20,
              total: state.transactions.count,
              onChange: (pageNum) => {
                setCurrentPage(pageNum);
              },
            }
          }
        >
          <TableColumn title="Data" dataIndex="createdAt" key="createdAt" render={formattedDate} width={200} />
          <TableColumn title="Nome pagador" dataIndex="originName" key="originName" width={250} />
          <TableColumn title="Nome recebedor" dataIndex="destinyName" key="destinyName" width={250} />
          <TableColumn title="Descrição" dataIndex="description" key="description" width={250} />
          <TableColumn title="Valor bruto" dataIndex="amount" key="amount" render={format} />
          <TableColumn title="Taxa" dataIndex="fee" key="fee" render={formatFee} />
          <TableColumn title="Valor Taxa" dataIndex="feeAmount" key="feeAmount" render={format} />
          <TableColumn title="Valor líquido" dataIndex="paymentAmount" key="paymentAmount" render={format} />
        </Table>
      </TableContainer>
    </Container>
  );
};

export default Usuarios;
